<script lang="ts">
  import {RecapService} from '@/services';
  import Dialog from '../../components/dialog/Dialog.svelte';
  import {draftStore, project, preview, step} from '@/store';
  import Swal from 'sweetalert2';
  import {DraftState} from '@/store/drafts';
  import {onDestroy, onMount} from 'svelte';
  import recap, {RecapProject} from '@/store/recap';
  import {STEP} from '@/types/common';

  const recapService = new RecapService();

  export let isSaveDialogOpen = false;

  let rawRecap: RecapProject;
  let projectName: string;
  let isSavingProject = false;

  const recapSubscription = recap.subscribe(value => {
    rawRecap = value;
    projectName = value.recap_name;
  });

  async function saveAsProject() {
    isSavingProject = true;

    try {
      recap.update(value => {
        value.recap_name = projectName;
        return value;
      });

      const result = await recapService.update(rawRecap.id, {
        step: $step,
        recap_name: rawRecap.recap_name,
        timestamps: rawRecap.timestamps,
        transcription: rawRecap.transcription?.map(value => {
          value.isFollowingText = false;
          value.isSearchWord = false;
          return value;
        })
      });

      console.log({result});

      Swal.fire({
        position: 'bottom-end',
        icon: 'success',
        title: 'Changes Saved',
        showConfirmButton: false,
        timer: 1500,
        toast: true
      });
    } catch (error: any) {
      console.error(error.toString());
      Swal.fire({
        position: 'bottom-end',
        icon: 'error',
        title: 'Saving Failed',
        showConfirmButton: false,
        timer: 1500,
        toast: true
      });
    }

    isSavingProject = false;
    isSaveDialogOpen = false;
  }

  onDestroy(() => {
    recapSubscription();
  });
</script>

<Dialog bind:isDialogOpen={isSaveDialogOpen} useIfShow={true}>
  <div class="pointer-events-none flex h-full w-full items-center justify-center">
    <div
      class="pointer-events-auto mx-4 h-auto w-full min-w-[280px] max-w-[680px] rounded-2xl border border-zinc-400 bg-white shadow-lg dark:border-zinc-600 dark:bg-zinc-700"
    >
      <div class="flex items-center p-6 text-zinc-900 dark:text-zinc-200">
        <div class="flex items-center gap-3 py-1.5">
          <div class="flex items-center rounded-full bg-rose-500 p-2 px-2 font-bold text-zinc-100">
            <i class="fa-solid fa-pen"></i>
          </div>
          <h1 class="text-3xl font-bold text-rose-500 dark:text-rose-500">Save Project</h1>
        </div>
        <button
          on:click={() => (isSaveDialogOpen = false)}
          class="ml-auto mr-2 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-600"
        >
          <i class="fa-solid fa-x"></i>
        </button>
      </div>
      <hr class="border dark:border-zinc-600" />
      <div class="grid p-6">
        <div class="py-2">
          <label for="name" class="block text-sm font-medium text-gray-800 dark:text-zinc-200">Project Name</label>
          <div class="flex pt-2">
            <input
              bind:value={projectName}
              name="name"
              type="text"
              placeholder=""
              class="block w-full rounded rounded-tl-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-gray-500 placeholder-gray-300 focus:border-primary focus:outline-none focus:ring focus:ring-primary focus:ring-opacity-40 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200 dark:placeholder-zinc-500 dark:focus:border-blue-300"
              required
            />
          </div>
        </div>
      </div>
      <hr class="border dark:border-zinc-600" />
      <div class="flex justify-end gap-2 p-6">
        <button
          on:click={() => (isSaveDialogOpen = false)}
          class="{isSavingProject
            ? 'bg-zinc-100'
            : 'border border-2 border-zinc-400'} flex w-full items-center rounded-md px-3 py-2 font-medium text-zinc-400 lg:w-auto"
          disabled={isSavingProject}
        >
          <span>Cancel</span>
        </button>
        <button
          on:click={() => saveAsProject()}
          class="flex w-full items-center gap-1 rounded-md bg-rose-500 px-3 py-2 font-medium text-zinc-100 hover:bg-rose-600 lg:w-auto"
          disabled={isSavingProject}
        >
          <div
            class="{isSavingProject
              ? ''
              : 'hidden'} spinner h-4 w-4 !border-zinc-100 !border-t-rose-500 dark:!border-zinc-700 dark:!border-t-rose-500"
          ></div>
          <i class="{isSavingProject ? 'hidden' : ''} fa-solid fa-floppy-disk" />
          <span>Save Project</span>
        </button>
      </div>
    </div>
  </div>
</Dialog>
